import { render, staticRenderFns } from "./collaborators_indicator.vue?vue&type=template&id=be0537e8"
import script from "./collaborators_indicator.vue?vue&type=script&lang=js"
export * from "./collaborators_indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports